import { SVGProps, Ref, forwardRef } from 'react';

export const ForwardOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.722 6.233c.722-.555 1.738-.067 3.768.91l2.92 1.403C10.47 10.017 12 10.753 12 12s-1.53 1.983-4.59 3.454l-2.92 1.403-.715.342c-1.453.687-2.295 1.006-2.914.66l-.14-.092c-.63-.486-.71-1.52-.72-3.47L0 13.403v-2.806c0-2.539 0-3.808.722-4.364m1.15 1.697c-.068.56-.072 1.369-.072 2.667v2.806c0 1.298.004 2.105.072 2.666.405-.15.967-.414 1.839-.834l2.919-1.403c1.588-.763 2.582-1.247 3.206-1.674q.13-.091.213-.158a4 4 0 0 0-.213-.158c-.624-.427-1.618-.91-3.206-1.674L3.71 8.765c-.871-.42-1.432-.684-1.838-.835"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.722 6.233c.722-.555 1.738-.067 3.768.91l2.92 1.403C22.47 10.017 24 10.753 24 12s-1.53 1.983-4.59 3.454l-2.92 1.403-.715.342c-1.453.687-2.295 1.006-2.914.66l-.14-.092c-.63-.486-.71-1.52-.72-3.47L12 13.403v-2.806c0-2.539 0-3.808.722-4.364m1.15 1.697c-.069.56-.072 1.369-.072 2.667v2.806c0 1.298.004 2.105.072 2.666.406-.15.967-.414 1.839-.834l2.919-1.403c1.588-.763 2.582-1.247 3.206-1.674q.13-.091.213-.158a4 4 0 0 0-.213-.158c-.624-.427-1.618-.91-3.206-1.674l-2.92-1.403c-.871-.42-1.433-.684-1.838-.835"
                fill="currentColor"
            />
        </g>
    </svg>
));
ForwardOutlinedSize24Glyph.displayName = 'ForwardOutlinedSize24Glyph';
